import {ActionCreatorWithoutPayload, createAction, createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import {LoadedSettings} from "~/types/setting-type.ts";

export interface SettingState {
    erpSystem: string,
    links: {
        terms: {
            href: string
        },
        chartfields: {
            href: string
        }
    },
    meta: {
        loaded: boolean,
        noPermissions: boolean
    },
}

export const initialState: SettingState = {
    erpSystem: '',
    links: {
        terms: {
            href: ''
        },
        chartfields: {
            href: ''
        }
    },
    meta: {
        loaded: false,
        noPermissions: false
    },
};

const slice = createSlice({
        name: 'settings',
        initialState: initialState,
        reducers: {
            receiveSettings: (draft: Draft<SettingState>, {payload}: PayloadAction<LoadedSettings>) => {
                draft.erpSystem = payload.erpSystem;
                draft.links = payload._links;
                draft.meta.loaded = true;
                draft.meta.noPermissions = false;
            },
            setNoPermissions: (draft: Draft<SettingState>) => {
                draft.meta.loaded = true;
                draft.meta.noPermissions = true;
            },
        }
    }
);

const loadSettings: ActionCreatorWithoutPayload = createAction('settings/loadSettings');

export const actions = {
    ...slice.actions,
    loadSettings
};

export default slice.reducer;
